module.exports = __webpack_public_path__ + "static/media/xtra-green.487f2a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/xtra-green.jpg
// module id = 206
// module chunks = 0